/**
 * Nazwa marki do wyświetlenia. Marki w statystykach to znormalizowane keywordy, więc przychodzą małą
 * literą — podnosimy pierwszą literę każdego słowa, tak jak robi to klasa `.capitalize` na wykresach
 * panelu. Liter, które już są wielkie, nie ruszamy, żeby nie zepsuć akronimów (`IKEA`).
 *
 * `#` liczy się jak separator, bo marki spod tagu przychodzą z tym prefiksem (`#acme group`).
 */
export const brandLabel = (brand: string): string =>
  brand.replace(
    /(^|[\s#])(\p{Ll})/gu,
    (_match, separator: string, letter: string) => separator + letter.toUpperCase()
  );
